import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
    $('.srg-slick-article-slider').each(function() {
        let $slider = $(this);
        $slider.slick({
            'slidesToShow': 1,
            'slidesToScroll': 1,
            'infinite': true,
            'dots': true,
            'arrows': false,
            'speed': 500,
            'fade': true,
            'cssEase': 'linear'
        });
    })
})
